export class SelectFilteredUsers {
    static readonly type = '[User] SelectFilteredUsers';
}
